import React from 'react';
import { useField } from 'react-final-form';
import Labels from '../../enums/Labels';

import 'FormInputs/InputName/InputName.css';
import { Name, TafChangeEvent } from '@taf-ui/core';
import { TafNameInput } from '@taf-ui/react';
import { isBrand, translate } from '../../utils/utils';
import AppStorage from '../../Storage/Storage';
import Brand from '../../enums/Brand';

type Props = {
  onBlurHandler?: () => void;
};

const InputName: React.FunctionComponent<Props> = ({ onBlurHandler }) => {
  const storage = AppStorage.getInstance();
  const initials = useField('initials');
  const firstName = useField('firstName');
  const middleName = useField('middleName');
  const surnameField = useField('surname');

  const isWefox = isBrand(Brand.wefox);
  const isFirstNameMode = isWefox;

  const validateName = () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const valueToValidate = isFirstNameMode
      ? firstName.input.value
      : initials.input.value;

    if (!valueToValidate || !surnameField.input.value) {
      return translate(Labels.ERROR_REQUIRED, storage.getLocale);
    }
  };

  const handleChange = (e: CustomEvent<TafChangeEvent<Name>>) => {
    initials.input.onChange(e.detail.value.initials);
    middleName.input.onChange(e.detail.value.middleName);
    surnameField.input.onChange(e.detail.value.surname);
    if (onBlurHandler) {
      onBlurHandler();
    }
  };

  return (
    <div className="name-input-wrapper">
      <TafNameInput
        inputId="insuredName"
        name="insuredName"
        initialsOrFirstName={'initials'}
        isMiddleNameHidden={isWefox}
        labels={{
          initialsField: translate(
            Labels.PERSONAL_DETAILS_INITIALS,
            storage.getLocale,
          ),
          middleNameField: translate(
            Labels.PERSONAL_DETAILS_MIDDLE_NAME,
            storage.getLocale,
          ),
          surnameField: translate(
            Labels.PERSONAL_DETAILS_LAST_NAME,
            storage.getLocale,
          ),
        }}
        value={{
          initials: initials.input.value as string,
          middleName: middleName.input.value as string,
          surname: surnameField.input.value as string,
        }}
        required={true}
        validationMessage={validateName()}
        validationState={validateName() ? 'error' : undefined}
        onTafChange={handleChange}
        isSurnameCapitalized={!isWefox}
      ></TafNameInput>
    </div>
  );
};

export default InputName;
